export enum GetManySamplesStatus {
  ON_HOLD = "on_hold",
  DAMAGED = "damaged",
  RESERVED = "reserved",
  DEPLETED = "depleted",
  AVAILABLE = "available",
}
